exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.animateAccordion-enter-active,\n.animateAccordion-leave-active {\n    -webkit-transition: all 0.2s;\n    transition: all 0.2s;\n    max-height: 230px;\n}\n.animateAccordion-enter,\n.animateAccordion-leave-to\n{\n    opacity: 0;\n    max-height: 0px;\n}\n\n/*対応バージョン一覧表示用スタイルは、FAQ.vueに書かれているスタイルがこのファイルにも適用されるのでそちらを参照*/\n", ""]);

// exports
